import { ReactElement, useState } from 'react';

import ReactSelect, { OptionType } from 'dashboard/components/ReactSelect';
import Button from 'design-system/components/Button';
import Modal from 'design-system/components/Modal/Modal';
import Spacer from 'design-system/components/Spacer';

interface UpdateSourceModalProps {
  onUpdateSources: (values: string[]) => void;
  trigger: ReactElement;
  options: OptionType[];
  selectedOptions: string[];
}

const UpdateSourceModal = ({
  trigger,
  selectedOptions: initialOptions,
  onUpdateSources,
  options,
}: UpdateSourceModalProps) => {
  const [selectedSources, setSelectedSources] = useState<string[]>(initialOptions);
  const [isOpen, setIsOpen] = useState(false);

  const handleCloseModal = (value: boolean) => {
    if (isOpen && !value) {
      setSelectedSources(initialOptions);
    }

    setIsOpen(value);
  };

  const handleAddSource = () => {
    if (selectedSources.length > 0) {
      onUpdateSources(selectedSources);
      setIsOpen(false);
    }
  };

  return (
    <Modal size='md' open={isOpen} onOpenChange={handleCloseModal} trigger={trigger}>
      <Modal.Title>Update sources</Modal.Title>
      <>
        Source(s)
        <ReactSelect
          isMulti
          value={selectedSources}
          options={options}
          onChange={setSelectedSources}
          menuPlacement='bottom'
          preserveOrder
          portal
          styles={{
            menuPortal: (base) => ({
              ...base,
              pointerEvents: 'auto',
            }),
          }}
        />
        <Spacer height={2} />
        <Button
          id='add-source-modal__submit-button'
          disabled={selectedSources.length < 1}
          width='button'
          onClick={handleAddSource}
        >
          Update
        </Button>
      </>
    </Modal>
  );
};

export default UpdateSourceModal;
